export default function EducationsPage() {
  return (
    <div>EducationsPage</div>
  )
}
